module.exports = __webpack_public_path__ + "static/media/outlet_app_icon.06c20c52.svg";